module.exports = __webpack_public_path__ + "static/media/Portrait-10253.e6d61970.jpg";